import React, {ReactElement} from 'react';
import {makeStyles} from '@material-ui/styles';
import {DEFAULT_BLACK_COLOR} from 'src/style/variable';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import HelperUtils from '@shared/utils/HelperUtils';

const PayInPaymentsDetailsStyles = makeStyles({
  wrapper: {
    flex: 1,
    color: DEFAULT_BLACK_COLOR
  },
  sectionWrapper: {
    display: 'flex',
    lineHeight: '2rem',
    fontSize: '1.2rem',
    alignItems: 'center'
  },
  strong: {
    paddingLeft: '0.2rem',
    color: DEFAULT_BLACK_COLOR
  }
});

const PayInPaymentSuccessDetails = (props: any): ReactElement => {
  const classes = PayInPaymentsDetailsStyles();
  const installmentDetails = useSelector(
    (state: any) => state.payments.installmentDetails
  );
  const {t} = useTranslation();
  const renderSection = (text: string, value: string | number): any => {
    return (
      <div className={classes.sectionWrapper}>
        <span>{text}:</span>
        <strong className={classes.strong}>{value}</strong>
      </div>
    );
  };

  const renderPaymentSuccessDetails = () => {
    const currentDate = HelperUtils.formatDisplayDate(new Date(), 'YYYY-MM-DD');

    let nextPaymentDate = installmentDetails?.instalment_start_date;

    let remainingPayments = installmentDetails?.total_installments;

    let amountPaidToday = 0;

    const firstPaymentDate = installmentDetails?.instalment_start_date;

    if (currentDate === firstPaymentDate) {
      amountPaidToday = installmentDetails?.min_instalment_amount;
      if (amountPaidToday > 0)
        remainingPayments = parseInt(remainingPayments) - 1;
      nextPaymentDate = installmentDetails?.next_installment_date;
    }

    return (
      <div className={classes.wrapper}>
        {/* Amount Paid Today */}
        {renderSection(
          t('INSTALLMENTS.AMOUNT_PAID_TODAY'),
          HelperUtils.formatCurrencyAmount(amountPaidToday) || ''
        )}
        {/* Remaining Payments */}
        {renderSection(t('INSTALLMENTS.REMAINING_PAYMENTS'), remainingPayments)}
        {/* Next Payment Date */}
        {renderSection(
          t('INSTALLMENTS.NEXT_PAYMENT_DATE'),
          HelperUtils.formatDisplayDate(nextPaymentDate || '')
        )}
      </div>
    );
  };
  return <div>{renderPaymentSuccessDetails()}</div>;
};

export default PayInPaymentSuccessDetails;
